import React from "react";
import { Control } from "react-hook-form";
import { UseFormSelect } from "./UseFormSelect";
import { SxProps } from "@mui/material";
import { useTranslation } from "react-i18next";

interface UseFormSelectSupplyTypeProps {
  control: Control
  name: string
  sx: SxProps
}

export const UseFormSelectSupplyType: React.FC<UseFormSelectSupplyTypeProps> = ({
  control,
  name,
  sx = {}
}) => {
  const { t } = useTranslation()
  
  return (
    <UseFormSelect
      control={control}
      name={name}
      items={[
        {value: '-', label: t('contact_order_detail.no_setting')},
        {value: 'EXTERNAL', label: t('contact_order_detail.external')},
        {value: 'INTERNAL', label: t('contact_order_detail.internal')},
      ]}
      sx={{
        width: '200px',
        ...sx,
      }}
    />
  )
}